import type { ProfileCommon } from "@/core/types";

import { ALLOWED_42CFRP2_EMAIL_DOMAINS } from "../constants/predicates";

type EmailPredicateProps = {
  profile?: ProfileCommon;
};

// Federal regulation 42 CFR Part 2
export function isAllowed42CFRP2Email({ profile }: EmailPredicateProps) {
  if (!profile?.email) return false;

  const domain = profile.email.split("@")[1]?.toLowerCase();

  return ALLOWED_42CFRP2_EMAIL_DOMAINS.includes(domain);
}
